import React from 'react'
import styled from 'styled-components'
import Grid from '@material-ui/core/Grid';
import TextField from 'components/TextField'
import FormSection from 'components/FormSection'
import { required, isEmail } from 'helpers/Validators'
import WysiwygEditor from 'components/WysiwygEditor'
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTimes } from '@fortawesome/free-solid-svg-icons'

const defaultValue = `<p>Wyrażam zgodę na przetwarzanie moich danych osobowych dla potrzeb rekrutacji (zgodnie z art. 6 ust. 1 lit. a Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE).</p>`

const RestoreBttn = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0.5rem;
`

const Approval = () => (
  <FormSection
    title={(
      <Typography variant="h6" component="h2">
        Zgoda na przetwarzanie danych osobowych
      </Typography> 
    )}
    subtitle={(
      <Typography component="p">
        Treść zgody na przetwarzanie danych osobowych
      </Typography>
    )}
  >
    <div className="approval">
      <WysiwygEditor
        name="approval"
        type="text"
        label="Approval"
        renderAfterEditor={(onChange) => (
          <RestoreBttn
            onClick={() => {
                onChange(defaultValue)
            }}
          >
            <FontAwesomeIcon icon={faPen} style={{ marginRight: '0.5rem' }}/>Przywróć klauzulę domyślną
          </RestoreBttn>
        )}

      />
    </div>
  </FormSection>
)

export default Approval